import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Stack,
  Card,
  ChoiceList,
  Listbox,
  TextField,
  Checkbox,
  PageActions,
  FormLayout,
  Layout,
  Page,
  DropZone,
  Modal,
  Thumbnail,
  Text,
  Toast,
  List,
  InlineError,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { Editor } from "@tinymce/tinymce-react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import axiosDefault from "axios";
import LoadingScreen from "../../Components/LoadingScreen";
const AddEditProject = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, "")
      .replace(/[\s_-]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const [isSaving, setIsSaving] = useState(false);
  const handleChangeTitle = (value) => {
    setItem({
      ...item,
      title: value,
      alias: slugify(value),
      seoTitle: slugify(value),
    });
    setTitleError("");
  };
  const [titleError, setTitleError] = useState("");
  const handleChangeAlias = (value) => {
    setItem({ ...item, alias: value });
    setAliasError("");
  };
  const [aliasError, setAliasError] = useState("");
  const handleChangeDescription = (value) => {
    setItem({ ...item, description: value });
  };
  const handleChangeText = (value) => {
    setItem({ ...item, text: value });
  };
  const handleChangeClient = (value) => {
    setItem({ ...item, client: value });
  };
  const handleChangeDirectors = (value) => {
    setItem({ ...item, directors: value });
  };
  const handleChangeCinematographer = (value) => {
    setItem({ ...item, cinematographer: value });
  };
  const handleChangeColorist = (value) => {
    setItem({ ...item, colorist: value });
  };
  const handleChangeAgency = (value) => {
    setItem({ ...item, agency: value });
  };
  const handleChangeDate = (value) => {
    setItem({ ...item, date: value });
  };
  const handleChangeVimeoId = (value) => {
    setItem({ ...item, vimeoId: value });
  };
  const handleChangeMetaTitle = (value) => {
    setItem({ ...item, seoTitle: value });
  };
  const handleChangeMetaDescription = (value) => {
    setItem({ ...item, seoDescription: value });
  };
  const handleChangeChecked = (value) => {
    setItem({ ...item, active: value });
  };
  const handleChangeFeatured = (value) => {
    setItem({ ...item, featured: value });
  };
  const [file, setFile] = useState();
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFile((file) => acceptedFiles[0]),
    []
  );

  const validImageTypes = [
    "image/gif",
    "image/jpeg",
    "image/png",
    "image/json",
    "image/webp",
  ];
  const fileUpload = !file && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs, jpegs, svgs,webp and jsons"}
    />
  );
  const uploadedFile = file && (
    <Stack>
      <div>
        {file.name}{" "}
        <Text variant="bodySm" as="p">
          {file.size} bytes
        </Text>
      </div>
    </Stack>
  );

  const sendImage = (file) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", file[file.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeySeo.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          seoImage:
            validImageTypes.indexOf(file[file.length - 1].type) > 0
              ? window.URL.createObjectURL(file[file.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [filesMain, setFilesMain] = useState();
  const handleDropZoneMain = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesMain((filesMain) => acceptedFiles[0]),
    []
  );
  const fileUploadMain = !filesMain && <DropZone.FileUpload />;
  const uploadedFilesMain = filesMain && (
    <Stack>
      <div className="maxtextwidth">
        {filesMain.name}{" "}
        <Text variant="bodySm" as="p">
          {filesMain.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const [imageError, setImageError] = useState("");

  const imageKey = useRef("");
  const imageKeyThumbnail = useRef("");
  const imageKeySeo = useRef("");
  const [isImageUploading, setIsImageUploading] = useState(false);
  const sendImageMain = (filesMain) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", filesMain[filesMain.length - 1]);

    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKey.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          image:
            validImageTypes.indexOf(filesMain[filesMain.length - 1].type) > 0
              ? window.URL.createObjectURL(filesMain[filesMain.length - 1])
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
        setImageError("");
      })
      .catch(function (error) {});
  };

  const [filesThumbnail, setFilesThumbnail] = useState();
  const handleDropZoneThumbnail = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesThumbnail((filesThumbnail) => acceptedFiles[0]),
    []
  );
  const fileUploadThumbnail = !filesThumbnail && <DropZone.FileUpload />;
  const uploadedFilesThumbnail = filesThumbnail && (
    <Stack>
      <div className="maxtextwidth">
        {filesThumbnail.name}{" "}
        <Text variant="bodySm" as="p">
          {filesThumbnail.size} bytes
        </Text>
      </div>
    </Stack>
  );
  const sendImageThumbnail = (filesThumbnail) => {
    setIsImageUploading(true);
    const form_data = new FormData();
    form_data.append("entity_type", "project");
    form_data.append("image", filesThumbnail[filesThumbnail.length - 1]);
    axios
      .post(`/s3/save-file`, form_data)
      .then((result) => {
        imageKeyThumbnail.current = result.data.data.file_key;
        setIsImageUploading(false);
        setItem({
          ...item,
          thumbnail:
            validImageTypes.indexOf(
              filesThumbnail[filesThumbnail.length - 1].type
            ) > 0
              ? window.URL.createObjectURL(
                  filesThumbnail[filesThumbnail.length - 1]
                )
              : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
        });
      })
      .catch(function (error) {});
  };
  const [activeToast, setActiveToast] = useState(false);
  const toggleActiveToast = useCallback(
    () => setActiveToast((activeToast) => !activeToast),
    []
  );
  const [toastContent, setToastContent] = useState("");
  const toastMarkup = activeToast ? (
    <Toast content={toastContent} onDismiss={toggleActiveToast} />
  ) : null;
  const [item, setItem] = useState({
    title: "",
    alias: "",
    client: "",
    directors: "",
    cinematographer: "",
    colorist: "",
    agency: "",
    date: "",
    description: "",
    text: "",
    image: "",
    thumbnail: "",
    seoImage: "",
    seoTitle: "",
    seoDescription: "",
    seoImage: "",
    active: true,
    vimeoId: "",
    featured: false,
  });
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/projects/${id}`)
        .then((result) => {
          setIsSaving(false);
          setItem({
            title: result?.data?.data?.title ? result.data.data.title : "",
            alias: result?.data?.data?.alias ? result.data.data.alias : "",
            client: result?.data?.data?.client ? result.data.data.client : "",
            directors: result?.data?.data?.directors
              ? result.data.data.directors
              : "",
            cinematographer: result?.data?.data?.cinematographer
              ? result.data.data.cinematographer
              : "",
            colorist: result?.data?.data?.colorist
              ? result.data.data.colorist
              : "",
            agency: result?.data?.data?.agency ? result.data.data.agency : "",
            vimeoId: result?.data?.data?.vimeo_id
              ? result.data.data.vimeo_id
              : "",
            date: result?.data?.data?.date ? result.data.data.date : "",
            description: result?.data?.data?.description
              ? result.data.data.description
              : "",
            text: result?.data?.data?.text ? result.data.data.text : "",
            image: result?.data?.data?.image ? result.data.data.image : "",
            thumbnail: result?.data?.data?.thumbnail
              ? result.data.data.thumbnail
              : "",
            seoTitle: result?.data?.data?.seo_title
              ? result.data.data.seo_title
              : "",
            seoDescription: result?.data?.data?.seo_description
              ? result.data.data.seo_description
              : "",
            seoImage: result?.data?.data?.seo_image
              ? result.data.data.seo_image
              : "",
            active: result?.data?.data?.is_active ? true : false,
            featured: result?.data?.data?.is_featured ? true : false,
          });
        })
        .catch((err) => console.log(err));
  }, []);
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Project`}
      breadcrumbs={[
        {
          onAction: () => navigate(`/admin/projects`),
        },
      ]}
    >
      <FormLayout>
        <Card sectioned>
          <FormLayout>
            <Checkbox
              label="Is Featured"
              checked={item.featured}
              onChange={handleChangeFeatured}
            />
            <FormLayout.Group>
              <TextField
                label="Title"
                value={item.title}
                onChange={handleChangeTitle}
                error={titleError}
              />

              <TextField
                label="Alias"
                value={item.alias}
                onChange={handleChangeAlias}
                error={aliasError}
              />
            </FormLayout.Group>

            <FormLayout.Group>
              <TextField
                label="Client"
                value={item.client}
                onChange={handleChangeClient}
              />

              <TextField
                label="Directors"
                value={item.directors}
                onChange={handleChangeDirectors}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="DP"
                value={item.cinematographer}
                onChange={handleChangeCinematographer}
              />

              <TextField
                label="Colorist"
                value={item.colorist}
                onChange={handleChangeColorist}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <TextField
                label="Agency"
                value={item.agency}
                onChange={handleChangeAgency}
              />
              <TextField
                label="Date"
                value={item.date}
                onChange={handleChangeDate}
              />
            </FormLayout.Group>
            <TextField
              label="Vimeo ID"
              value={item.vimeoId}
              onChange={handleChangeVimeoId}
            />
            <FormLayout.Group>
              <TextField
                label="Description"
                value={item.description}
                onChange={handleChangeDescription}
                multiline={4}
              />

              <TextField
                label="Text"
                value={item.text}
                onChange={handleChangeText}
                multiline={4}
              />
            </FormLayout.Group>
            <FormLayout.Group>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Image
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.image ? item.image : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneMain}
                      onDropAccepted={sendImageMain}
                      allowMultiple={false}

                      // variableHeight
                    >
                      {uploadedFilesMain}
                      {fileUploadMain}
                    </DropZone>
                  </div>
                </div>
                <InlineError message={imageError} />
              </FormLayout>
              <FormLayout>
                <Text as="p" fontWeight="regular">
                  Thumbnail
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                  }}
                >
                  <div style={{ float: "left" }}>
                    <Thumbnail
                      size="large"
                      source={item.thumbnail ? item.thumbnail : ""}
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginLeft: "10px",
                    }}
                  >
                    <DropZone
                      onDrop={handleDropZoneThumbnail}
                      onDropAccepted={sendImageThumbnail}
                      allowMultiple={false}
                      // variableHeight
                    >
                      {uploadedFilesThumbnail}
                      {fileUploadThumbnail}
                    </DropZone>
                  </div>
                </div>
              </FormLayout>
            </FormLayout.Group>
          </FormLayout>
        </Card>
        <Card sectioned title="Search engine listing preview">
          <FormLayout>
            <Text variant="bodyMd" as="p" fontWeight="regular">
              SEO Image
            </Text>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div style={{ float: "left" }}>
                <Thumbnail
                  size="large"
                  source={item.seoImage ? item.seoImage : ""}
                />
              </div>
              <div
                style={{
                  width: "100%",
                  marginLeft: "10px",
                }}
              >
                <DropZone
                  accept=".png,.jpeg,.jpg,.svg,.json,.webp"
                  //   type="file"
                  allowMultiple={false}
                  onDrop={handleDropZoneDrop}
                  onDropAccepted={sendImage}
                >
                  {uploadedFile}
                  {fileUpload}
                </DropZone>
              </div>
            </div>
            <TextField
              label="Page Title"
              value={item.seoTitle}
              onChange={handleChangeMetaTitle}
            />
            <TextField
              label="Description"
              value={item.seoDescription}
              onChange={handleChangeMetaDescription}
              multiline={4}
            />
          </FormLayout>
        </Card>
        <FormLayout.Group condensed>
          <Card sectioned title="Visibility">
            <FormLayout>
              <Checkbox
                label="Is Active"
                checked={item.active}
                onChange={handleChangeChecked}
              />
              {/* <ChoiceList
                choices={[
                  { label: "Visible", value: "visible" },
                  { label: "Hidden", value: "hidden" },
                ]}
                selected={selected}
                onChange={handleChoiceListChange}
              /> */}

              {/* {visibilityButtonText === "Clear date" && (
                <FormLayout.Group>
                  <TextField
                    label="Visibility Date"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="date"
                  />
                  <TextField
                    label="Visibility Time"
                    value={visibilityDateValue}
                    onChange={handleChangeVisibilityDate}
                    type="time"
                  />
                </FormLayout.Group>
              )} */}
              {/* <Button plain onClick={handleVisibilityButton}>
                {visibilityButtonText}
              </Button> */}
            </FormLayout>
          </Card>
        </FormLayout.Group>
      </FormLayout>

      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && [
            {
              content: "Delete",
              destructive: true,
              loading: isSaving && true,
              onClick: () => {
                setIsSaving(true);
                axios
                  .delete(`/projects/${id}`)
                  .then((result) => {
                    navigate(`/admin/projects`);
                  })
                  .catch((err) => console.log(err));
              },
            },
          ]
        }
      />
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (!item.title || !item.alias || (!filesMain && props.type === "add")) {
      !item.title && setTitleError("This field is required");
      !item.alias && setAliasError("This field is required");
      !filesMain &&
        props.type === "add" &&
        setImageError("The image is required");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      item.title && form_data.append("title", item.title);
      form_data.append("alias", item.alias);
      form_data.append("client", item.client);
      form_data.append("directors", item.directors);
      form_data.append("cinematographer", item.cinematographer);
      form_data.append("colorist", item.colorist);
      form_data.append("agency", item.agency);
      form_data.append("date", item.date);
      form_data.append("description", item.description);
      form_data.append("text", item.text);
      filesMain && form_data.append("image", imageKey.current);
      filesThumbnail &&
        form_data.append("thumbnail", imageKeyThumbnail.current);
      form_data.append("seo_title", item.seoTitle);
      form_data.append("seo_description", item.seoDescription);
      form_data.append("vimeo_id", item.vimeoId);
      file && form_data.append("seo_image", imageKeySeo.current);
      form_data.append("is_active", item.active ? 1 : 0);
      form_data.append("is_featured", item.featured ? 1 : 0);
      props.type === "edit" && form_data.append("_method", "PATCH");

      axios
        .post(`/projects${props.type === "edit" ? `/${id}` : ""}`, form_data)
        .then((res) => {
          if (props.type === "add") {
            navigate(`/admin/projects`);
          } else {
            setIsSaving(false);
            setToastContent("Changes have been saved succesffully");
            toggleActiveToast();
          }
        })
        .catch((error) => {
          // Error
          if (error.response) {
            setIsSaving(false);
            setAliasError(error.response.data.message);
          } else if (error.request) {
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};

export default AddEditProject;
